import { useMemo } from 'react';
import { normalizeLabel } from '../../utils/normalizeLabel';

import './styles.css';

export type HorizontalSelectProps = {
	items: (string | [name: string, index: number])[];
	selectedIndex: number;
	clickHandler: (index: number) => void;
	/**
	 * Used to set a data attribute "data-name" on the root element of this
	 * component.
	 *
	 * Useful for e2e testing.
	 */
	name?: string;
};

export const HorizontalSelect: React.FC<HorizontalSelectProps> = ({
	items,
	selectedIndex,
	clickHandler,
	name
}) => {
	const width = useMemo(() => 100 / items.length, [items.length]);
	const left = `${selectedIndex * width}%`;
	return (
		<div
			className="hz-select horizontal-select"
			data-name={name ? normalizeLabel(name) : undefined}
		>
			<div className="hz-select-indicator-box">
				<div className="hz-select-indicator-container">
					<div
						className="hz-select-indicator"
						style={{
							width: `${width}%`,
							left,
							transition: 'left 1s ease'
						}}
					/>
				</div>
			</div>

			{items
				.map((item, index): [string, number] =>
					typeof item === 'string' ? [item, index] : item
				)
				.map(([item, originalIndex], index) => (
					<div
						onClick={() => clickHandler(originalIndex)}
						className={`hz-select-option${
							selectedIndex === index
								? ' hz-select-option-active'
								: ''
						}`}
						data-item={normalizeLabel(item)} // useful for e2e testing
						key={index}
					>
						<div className="hz-select-option-label">{item}</div>
					</div>
				))}
		</div>
	);
};
